import {
  CarrierSchema,
  ServiceSchema,
} from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod/v4";

const servicesToShipViaMappingSchema = z.object({
  carrier: CarrierSchema,
  service: ServiceSchema,
  shipViaId: z.string(),
  shipViaCode: z.string(),
});

export const setAims360Integration = {
  name: "setAims360Integration" as const,
  input: z.object({
    bearerToken: z.string().min(1, "Bearer token is required"),
    baseUrl: z.string().min(1, "Base URL is required"),
    returnsEnabled: z.boolean().optional(),
    omsEnabled: z.boolean().optional(),
    aims360DefaultReturnReasonID: z.string().optional(),
    servicesToShipViaMappings: z
      .array(servicesToShipViaMappingSchema)
      .optional(),
  }),
  output: z.object({}),
};

export type SetAims360IntegrationInput = z.infer<
  typeof setAims360Integration.input
>;

export const updateAims360Integration = {
  name: "updateAims360Integration" as const,
  input: z.object({
    bearerToken: z.string().optional(),
    baseUrl: z.string().optional(),
    returnsEnabled: z.boolean().optional(),
    omsEnabled: z.boolean().optional(),
    warehouseCodes: z.array(z.string()).optional(),
    aims360DefaultReturnReasonID: z.string().optional(),
    servicesToShipViaMappings: z
      .array(servicesToShipViaMappingSchema)
      .optional(),
  }),
  output: z.object({}),
};

export type UpdateAims360IntegrationInput = z.infer<
  typeof updateAims360Integration.input
>;

export const getAims360Integration = {
  name: "getAims360Integration" as const,
  input: z.object({}),
  output: z.object({
    aims360Integration: z.optional(
      z.object({
        bearerToken: z.string(),
        baseUrl: z.string(),
        returnsEnabled: z.boolean(),
        omsEnabled: z.boolean(),
        aims360DefaultReturnReasonID: z.string().optional(),
        servicesToShipViaMappings: z
          .array(servicesToShipViaMappingSchema)
          .optional(),
      }),
    ),
  }),
};

export type GetAims360IntegrationOutput = z.infer<
  typeof getAims360Integration.output
>;

export const getAllShipViaCodes = {
  name: "getAllShipViaCodes" as const,
  input: z.object({}),
  output: z.object({
    shipViaCodes: z.array(
      z.object({ shipViaId: z.string(), shipViaCode: z.string() }),
    ),
  }),
};

export type GetAllShipViaCodesOutput = z.infer<
  typeof getAllShipViaCodes.output
>;

export const disconnectAims360Integration = {
  name: "disconnectAims360Integration" as const,
  input: z.object({}),
  output: z.object({}),
};
